<template>
	<div class="partner-box text-center">
        <swiper class = "swiper" :options="swiperOptionPartner">
			<swiper-slide>
				<div class="logo-wrap" v-for="(item,index) in listData" :key="index" >
					<img class="logo block width-full" :src="item">
				</div>
			</swiper-slide>
			<div class="swiper-pagination" slot="pagination"></div>
		</swiper>
    </div>
</template>

<script>
	import Vue from 'vue'
	import 'swiper/dist/css/swiper.css'
	import { swiper, swiperSlide } from 'vue-awesome-swiper'
	
	export default {
		data() {
			return {
				swiperOptionPartner:{
                    // loop: true,
                    // autoplay:true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    disableOnInteraction: false
				},
				listData:[]
			}
		},
		components: {
            swiper,
            swiperSlide,
		},
		created(){
			let i = 1;
			while(i<21){
				let num = i + '';
				if(i < 10) num = '0' + num;
				this.listData.push(require('@assets/img/logo/logo-' + num + '.png'));
				i ++;
			}
			
		},
	}
</script>

<style lang="scss">
	.partner-box{
		.swiper{
			padding: 2px 2px 60px 2px;
			font-size: 0;
			.logo-wrap{
				display: inline-block;
				position: relative;
				width: 20%;
				&::before,&::after{
					position: absolute;
					width: 4px;
					height: 4px;
					background: rgba($color: #3ED8C4, $alpha: 0.4);
				}
				&::before{
					content: '';
					top: -2px;
					left: -2px;
				}
				&:nth-child(5n)::after{
					content: '';
					right: -2px;
					top: -2px;
				}
				&:nth-child(n+16)::after{
					content: '';
					left: -2px;
					bottom: -2px;
				}
				&:last-child::before,&:last-child::after{
					right: auto;
					left: -2px;
					top: -2px;
					bottom: -2px;
					background: none;
					height: auto;
					border-top: 4px solid rgba($color: #3ED8C4, $alpha: 0.4);
					border-bottom: 4px solid rgba($color: #3ED8C4, $alpha: 0.4);
				}
				&:last-child::after{
					left: auto;
					right: -2px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/partnerBox.vue